import { render, staticRenderFns } from "./vacancy_page.vue?vue&type=template&id=1b2bd809&scoped=true&"
import script from "./vacancy_page.vue?vue&type=script&lang=js&"
export * from "./vacancy_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2bd809",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b2bd809')) {
      api.createRecord('1b2bd809', component.options)
    } else {
      api.reload('1b2bd809', component.options)
    }
    module.hot.accept("./vacancy_page.vue?vue&type=template&id=1b2bd809&scoped=true&", function () {
      api.rerender('1b2bd809', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/vacancy_page.vue"
export default component.exports